import React,{useState} from "react";
import {Form,Col,Row,Button, Container, Alert, Card} from "react-bootstrap";
import {YesNoDrop,NumInput,CustomDrop,TextInput,DateInput} from './dropdowns/components'
import regions from "./regions.json"

class PersonalHistory extends React.Component {
    constructor(props) {
        super(props);
    }
    handleChange = (event) =>{
        this.props.handler('personal_info',event);
    }
    handleGender = (e)=>{

    }
    render() {
        return (
            <Container style={{"maxWidth":"1600px"}}>
                <h3>Personal Information</h3>

                {/* Key Patient Fields Section */}
                <Card className="mb-4" style={{border: "2px solid #007bff", backgroundColor: "#f8f9fa"}}>
                    <Card.Header style={{backgroundColor: "#007bff", color: "white"}}>
                        <h5 className="mb-0">
                            <i className="fas fa-user-plus me-2"></i>
                            Required Patient Information
                        </h5>
                    </Card.Header>
                    <Card.Body>
                        <Alert variant="info" className="mb-3">
                            <strong>Important:</strong> Patient ID and Gender are required fields for database entry.
                        </Alert>
                        <Form.Row>
                            {this.props.data==null&&
                                <Form.Group as={Col} md={6}>
                                    <Form.Label style={{fontWeight: "bold", fontSize: "1.1em", color: "#007bff"}}>
                                        Patient ID <span style={{color: "red"}}>*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type={'text'}
                                        onBlur={this.props.patientID}
                                        required={true}
                                        placeholder={"XX-XXX"}
                                        disabled={this.props.disabled}

                                    />
                                    <Form.Text className="text-muted">
                                        Enter unique patient identifier (format: XX-XXX)
                                    </Form.Text>
                                </Form.Group>}

                            <Form.Group as={Col} md={6}>
                                <Form.Label style={{fontWeight: "bold", fontSize: "1.1em", color: "#007bff"}}>
                                    Gender <span style={{color: "red"}}>*</span>
                                </Form.Label>
                                <div >
                                    <CustomDrop
                                        title=""
                                        name="gender"
                                        disabled={this.props.disabled}
                                        val={this.props.data!=null? this.props.data:null}
                                        handler={this.props.handleGender}
                                        options={["","Male","Female"]}
                                        style={{border: "none", fontSize: "1.1em"}}
                                    />
                                </div>
                                <Form.Text className="text-muted">
                                    Required for patient record creation
                                </Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Card.Body>
                </Card>

                {/* Additional Patient Information */}
                <Card>
                    <Card.Header style={{backgroundColor: "#6c757d", color: "white"}}>
                        <h5 className="mb-0">Additional Information</h5>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            <Form.Row>
                                <NumInput title="Year of Birth" name="year_of_birth" disabled={this.props.disabled} val={this.props.data!=null? this.props.data:null} handler={this.handleChange}/>
                                <NumInput title="Age of Examination" name="examination_age" disabled={this.props.disabled} val={this.props.data!=null? this.props.data:null} handler={this.handleChange}/>
                                <CustomDrop title="Race" name="race" val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange} options={["","Caucasian","Other"]}/>
                            </Form.Row>

                            <Form.Row>
                                <CustomDrop title="Paternal origin" name="paternal_origin" val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange} options={regions}/>
                                <TextInput title="Paternal origin comments" name="paternal_origin_comments" val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                                <CustomDrop title="Maternal origin" name="maternal_origin" val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange} options={regions}/>
                                <TextInput title="Maternal origin comments" name="maternal_origin_comments" val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                            </Form.Row>

                            <Form.Row>
                                <NumInput title="Years of Education" name="years_education" disabled={this.props.disabled} val={this.props.data!=null? this.props.data:null} handler={this.handleChange}/>
                                <TextInput title="Occupation" name="occupation" val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                                <YesNoDrop title="Left Handed" name={'left_handed'} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                                <YesNoDrop title="Right Handed" name={'right_handed'} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                            </Form.Row>

                            <Form.Row>
                                <YesNoDrop title={"Smoker"} name={"smoker"} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                                <TextInput title={'If yes how many cigarettes a day'} name={'smoker_cigarettes'} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange} placeholder={"If No smoker leave blank"}/>
                            </Form.Row>

                            <Form.Row>
                                <YesNoDrop title={"Ex smoker"} name={"x_smoker"} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                                <TextInput title={"How many years stopped"} name={"years_stopped"} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                            </Form.Row>

                            <Form.Row>
                                <YesNoDrop title={"Exposure to pesticides"} name={"pesticides"} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                            </Form.Row>

                            <Form.Row>
                                <DateInput title={"Date of Death"} name={"date_of_death"} val={this.props.data!=null? this.props.data:null} disabled={this.props.disabled} handler={this.handleChange}/>
                            </Form.Row>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        )
    }
}

export default PersonalHistory;